module.exports = __webpack_public_path__ + "img/img_05.17571011.jpg";